import { render } from "./SelectableMedia.vue?vue&type=template&id=6ee7c423&scoped=true"
import script from "./SelectableMedia.vue?vue&type=script&lang=js"
export * from "./SelectableMedia.vue?vue&type=script&lang=js"

import "./SelectableMedia.vue?vue&type=style&index=0&id=6ee7c423&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee7c423"]])

export default __exports__